import { render, staticRenderFns } from "./ContributorTagsAttributes.vue?vue&type=template&id=efe0225c&scoped=true&"
import script from "./ContributorTagsAttributes.vue?vue&type=script&lang=js&"
export * from "./ContributorTagsAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe0225c",
  null
  
)

export default component.exports